import { isObjectDeeplyChanged } from '../../util/state';
import { State } from '../App/selector';

/**
 * Update flags for TariffSelection container
 */
export const getUpdateFlags = (newState: State, oldState: State) => {
    const { selectedTariffId, tariffs } = newState;
    const hasSelectedChanged = selectedTariffId !== oldState.selectedTariffId;
    const hasTariffsChanged = tariffs && isObjectDeeplyChanged(tariffs, oldState.tariffs);

    return {
        selected: hasSelectedChanged || hasTariffsChanged,
    };
};
